import { render, staticRenderFns } from "./intelRecommend.vue?vue&type=template&id=5b10b4c2&scoped=true"
import script from "./intelRecommend.vue?vue&type=script&lang=js"
export * from "./intelRecommend.vue?vue&type=script&lang=js"
import style0 from "./intelRecommend.vue?vue&type=style&index=0&id=5b10b4c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10b4c2",
  null
  
)

export default component.exports